var navWidth = 10;

$(document).ready(function() {
	$('header nav ul li').each(function(){
		navWidth += $(this).outerWidth(true);
	});
});
	
window.sizeWin = function(){
	//var mobMenu = false;
	var hdrWidth, logoWidth, nrOfPage;	

	hdrWidth = $('header').width();
	logoWidth = $('#logo').width();
	nrOfPage = $('header nav ul li').length;

	if(hdrWidth <= "630"){
		$("#hdr_main_nav").prepend($("#options"));
		
	}else{
		$("#head-right").prepend($("#options"));
	}
	$("#options").show();	

	// if nav does not fit in the header, add mob class to nav and show mob menu button	
	if(hdrWidth >= 984){
		//alert(">= 984");
		if(window.mobMenu == true){
			
			window.bgnav.fadeOut('fast');
			
			//$('header nav').slideUp('fast', function(){
				window.mobMenu = false;
				$(this).removeClass('do');
				//$("#hdr_main_nav").css('display', 'block');
			//});
		}
		$('#hdr_main_nav').css('top', '');
		$("#hdr_main_nav").css('display', 'block');
	}else{
		$('#hdr_main_nav').css('top', ($('header').height()+9)+'px');
		$("#hdr_main_nav").css('display', 'none');
	}
	
	var contHeight = $('header').outerHeight() + $('#pageajax').outerHeight();
	var screenHeight = $('body').outerHeight() - $('footer').outerHeight();
	if(contHeight > screenHeight){
		$('footer').css("position","relative");
	}
}